import * as React from "react";
const RecoveryIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 51 51",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "m9.81 29 2.82-3.94 3.61-5.04h-3.61v-1.79l12.91-7.45 12.91 7.45v4.73l2.74-3.82 2.76 3.87v-7.95L25.54 4.43 7.13 15.06v4.96H3.39l3.74 5.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.95 25.92-2.76-3.86-2.74 3.82-3.69 5.16h3.69v2.1l-12.91 7.45-12.91-7.45v-5.12l-2.82 3.94-2.68-3.74v8.1l18.41 10.62 18.41-10.62v-5.28h3.66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.96 25.5c0 4.74 3.84 8.58 8.58 8.58s8.58-3.84 8.58-8.58-3.84-8.58-8.58-8.58-8.58 3.84-8.58 8.58zm13-1v2h-3.42v3.42h-2V26.5h-3.42v-2h3.42v-3.42h2v3.42z"
}));
export default RecoveryIcon;